import { render, staticRenderFns } from "./TenantNew.vue?vue&type=template&id=3590901c&scoped=true&lang=pug&"
import script from "./TenantNew.vue?vue&type=script&lang=js&"
export * from "./TenantNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590901c",
  null
  
)

export default component.exports